
    var riot = require('riot')
    riot.tag2('gb-product-info', '<a href="{$product.link()}"> <p class="gb-product__title">{$product.variant().title}</p> <p class="gb-product__price">{$product.variant().price}</p> </a>', '', '', function(opts) {
});

    
  


// WEBPACK FOOTER //
// ./src/tags/product/gb-product-info.tag.html